<template>
  <v-container class="no-margins">
    <v-expand-transition v-if="employees.length > 0">
      <v-list>
        <v-list-item-group>
          <template v-for="(emp, index) in employees">
            <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
            <v-list-item
              :key="`emp-${index}`"
              @click="empClick(emp)"
              :disabled="getIsDisabled(emp)"
              :class="type == 'instructor' ? 'v-list-item--three-line' : ''"
            >
              <v-list-item-avatar>
                <v-icon>{{
                  getRoleAvatar(emp, hasDepartments($route.params.id))
                }}</v-icon>
              </v-list-item-avatar>

              <v-list-item-content> 
                <v-list-item-title
                  >{{ displayName(emp) }}
                  <v-icon size="8" class="mr-1" v-if="isMaxApprenticesForInstructor(emp) && $route.name=='CompanyInstructors'"
                    >$sl-error</v-icon
                  >
                  <v-icon size="8" v-if="getNeedToReadInstructions(emp)==true && $route.name=='CompanyInstructors'"
                    >$sl-triangle</v-icon
                  >
                </v-list-item-title>
                <v-list-item-subtitle                  
                  v-if="type == 'instructor'"                  
                >{{getNoOfApprentices(emp)}} <span class="text-lowercase">{{getDescProf(emp)}}</span></v-list-item-subtitle>
                <!-- <v-list-item-subtitle v-if="type == 'instructor'" v-text="'3 lärlingar'"></v-list-item-subtitle> -->
                <v-list-item-subtitle
                  v-else-if="!['apprentice'].includes(type)"
                  v-text="getDescText(emp)"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-else
                  v-text="getApprDesc(emp.type, emp.toDate, get(emp, 'education.book.isActive', true))"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon class="icon-far-right">{{ nextIcon }}</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-expand-transition>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import find from "lodash/find";
import ActionButton from "@/components/Common/ActionButton";
import { CompanyRoles, InstructorAbilities } from "@/components/mixins";
import { get } from "lodash";

const SugarDate = require("sugar/date");

// @group Company
// CompanyEmployeeList component
export default {
  name: "CompanyEmployeeListItems",

  mixins: [CompanyRoles, InstructorAbilities],

  props: {
    emp: Array,
    type: {
      // `'String'`
      type: String,
      // 'all', 'apprentice', 'employed', 'instructor', 'companyEducationResponsible', 'distanceEducationAdministrator', 'administrator'
      default: "all",
    },
    nextIcon: {
      type: String,
      // `'String'`
      default: "$sl-arrow-right",
      // The default value is icon: `$sl-arrow-right`
    },
    //Next list
    nextTo: {
      // `'String'`
      type: String,
      // The default value is icon: `CompanyEmployee`
      default: "CompanyEmployee",
    },
  },

  watch: {
    emp: {
      handler: function () {
        this.init();
      },
    },
  },
  data() {
    return {
      employees: [],
      commitedDate: ''
    };
  },

  components: {
    ActionButton,
  },

  created() {
    this.init();
  },

  methods: {

    get, 
    
    init() {
      this.employees = this.emp;
      API.getInstructions()
      .then(({data}) => { 
        this.commitedDate = data.committedAt          
      })
      .catch(error => {
        console.log('Error', error)          
      })      
    },

    getNeedToReadInstructions(inst) {                   
      const lastReadInstructions = (inst.employed && inst.employed.readInstructionsOn) ? inst.employed.readInstructionsOn : null      

      if (lastReadInstructions) {
        return Boolean(new SugarDate.Date(this.commitedDate).isAfter(lastReadInstructions).raw)        
      }
      else 
        return true                        
    },
    isMaxApprenticesForInstructor(emp) {
      if (this.type == "instructor") {
        if (
          emp.apprentices &&
          emp.profession &&
          emp.profession.maxApprenticesForInstructor &&
          emp.profession.maxApprenticesForInstructor <= emp.apprentices.length
        ) {
          return true;
        }
      }
      return false;
    },
    getNoOfApprentices(emp) {
      if (emp.apprentices)
        return this.$tc("company.appr", emp.apprentices.length) + " - ";
    },
    getApprDesc(type, toDate, bookIsActive = true) {
      let ret,
        tdate = "";

      if (toDate && toDate != "") {
        tdate =
          ", " +
          this.$t("company.plan") +
          ". " +
          SugarDate.Date(toDate).format("%Y-%m-%d");
      }
      if (type == "QualificationTime")
        ret = this.$t("labels.apprentice") + " (KT)" + tdate;
      else ret = this.$t("labels.apprentice") + " (GU)" + tdate;

      if ( type === 'BasicEducation' && !bookIsActive )
        ret = `${ ret } (${ this.$t("ebook.inactive-title") })`
        
      return ret;
    },
    getDescProf(emp) {
      let ret = [];
      if (
        emp.employed &&
        emp.employed.instructorExemptions &&
        emp.employed.instructorExemptions.length > 0
      ) {
        emp.employed.instructorExemptions.forEach((element) => {
          if (element.profession && element.profession.name)
            ret.push(element.profession.name);
        });
      }
      if (
        emp.employed &&
        emp.employed.tradeCertificates &&
        emp.employed.tradeCertificates.length > 0
      ) {
        emp.employed.tradeCertificates.forEach((element) => {
          if (element.profession && element.profession.name)
            ret.push(element.profession.name);
        });
      }
      return ret.join(", ");
    },
    getDescText(emp) {
      if (this.$route.name == "CompanyInstructorApprentices")
        return this.getApprDesc(emp.type, emp.toDate);
      if (this.hasDepartments(this.$route.params.id) == false)
        return this.getShortRoleDescription(
          emp,
          this.hasDepartments(this.$route.params.id)
        );
      if (this.getDepartments(emp) == "")
        return this.getShortRoleDescription(
          emp,
          this.hasDepartments(this.$route.params.id)
        );
      return (
        this.getShortRoleDescription(emp, this.hasDepartments(this.$route.params.id)) //+ " (" + this.getDepartments(emp) + ")"
      );
    },
    /**
     * @vuese
     * Used to fetch workplace
     * @arg The arguments are  integers value representing company id and workplace id
     */
    getIsDisabled(e) {
      if (e && e.employed && e.employed.isActive == false) {
        return true;
      }
      return false;
    },

    /**
     * @vuese
     * Used to display full name
     */
    displayName(emp) {
      if (emp.employed) {
        if (!emp.employed.firstName && emp.employed.email) {
          return emp.employed.email;
        } else {
          return `${emp.employed.firstName} ${emp.employed.lastName}`;
        }
      }
      if (emp.apprentice) return `${emp.apprentice.firstName} ${emp.apprentice.lastName}`;
      return "";
    },

    /**
     * @vuese
     * Used to redirect once the the element of the list is clicked
     * @arg The argument is an string that used as route name
     */
    empClick(emp) {
      if (this.type === "myApprentices") {
        this.$nextTick(() => {
          this.$router.push({
            name: "CompanyApprentice",
            params: { id: emp.company.id, employee_id: emp.id, isApprentice: true },
          });
        });
      } else if (this.type === "all") {
        // Could be both apprentice and employed type
        if (emp.apprentice) {
          this.$nextTick(() => {
            this.$router.push({
              name: "CompanyApprentice",
              params: {
                id: this.$route.params.id,
                employee_id: emp.id,
                isApprentice: true,
              },
            });
          });
        } else {
          this.$nextTick(() => {
            this.$router.push({
              name: "CompanyEmployee",
              params: {
                id: this.$route.params.id,
                employee_id: emp.id,
                isApprentice: false,
              },
            });
          });
        }
        return;
      } else {
        this.$nextTick(() => {
          this.$router.push({
            name: this.nextTo,
            params: {
              id: this.$route.params.id,
              employee_id: emp.id,
              isApprentice: emp.apprentice ? true : false,
            },
          });
        });
      }
    },
    /**
     * @vuese
     * Used to fetch the list based on the type that is required
     * @arg The argument can be apprentice , employes list
     */
  },
};
</script>
